import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { IntlProvider } from "react-intl";
import TopBarProgress from "react-topbar-progress-indicator";
import { useRouter } from "next/dist/client/router";
import AOS from "aos";
import SSRProvider from "react-bootstrap/SSRProvider";
import server from "../src/api/server";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap.rtl.min.css";
import "aos/dist/aos.css";
import "../styles/globals.scss";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import "../styles/404.scss";
import Head from "next/head";
import Script from "next/script";
import App from "next/app";

const Loading = dynamic(() => import("../src/components/Shared/Loading"), {
  ssr: false,
});

const Header = dynamic(() => import("../src/components/Layout/Header"), {
  ssr: false,
});
const Footer = dynamic(() => import("../src/components/Layout/Footer"), {
  ssr: false,
});
const Seo = dynamic(() => import("@/src/components/Shared/Next-seo"), {
  ssr: false,
});

const languages = {
  ar: require("../src/content/languages/ar.json"),
  en: require("../src/content/languages/en.json"),
};

function MyApp({ Component, pageProps, props }) {
  const [Progress, setProgress] = useState(false);
  const [loading, setLoading] = useState(false);
  const router = useRouter();
  const { locale, defaultLocale, pathname, events } = useRouter();
  const messages = languages[locale];
  const dir = locale === "ar" ? "rtl" : "ltr";

  TopBarProgress.config({
    barThickness: 3,
    barColors: {
      0: "rgba(124, 192, 188, 0.9)",
      1.0: "#6c3d8e",
    },
  });

  const [styleContent, setStyleContent] = useState("");

  useEffect(() => {
    if (document.documentElement.scrollHeight < 2270)
      setStyleContent(`
          body .wrap::after{
            content:none !important;
          }
    `);
  }, [props]);

  useEffect(() => {
    const handleStart = (url) => {
      url !== pathname ? setLoading(true) : setLoading(false);
    };
    const handleComplete = () => setLoading(false);

    events.on("routeChangeStart", () => {
      handleStart();
      setProgress(true);
    });
    events.on("routeChangeComplete", () => {
      handleComplete();
      setProgress(false);
    });
    events.on("routeChangeError", handleComplete);
  }, [pathname, events]);

  useEffect(() => {
    AOS.init({
      once: true,
      disable: () => window.innerWidth < 800,
    });
    document.documentElement.dir = dir;
    document.body.style.direction = dir;
    document.body.setAttribute("dir", dir);
  }, [dir]);

  useEffect(() => {
    const handleRouteChange = (url) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "pageview",
        page: url,
      });
    };

    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events]);

  return (
    <>
      {/* <Seo
        title={props?.siteInfo?.appName?.[locale]}
        description={props?.siteInfo?.appDesc?.[locale]}
      /> */}
      <Head>
        <meta
          name="google-site-verification"
          content="vAEyPCjTKpH-q6ecWbvfTcdZfbcF6pMx7Z0KbFIBCco"
        />
      </Head>
      <Script
        id="gtm-script"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-MHHLNW2X');`,
        }}
      />
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-MHHLNW2X"
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
        ></iframe>
      </noscript>
      {Progress && <TopBarProgress />}
      <IntlProvider
        messages={messages}
        defaultLocale={defaultLocale}
        locale={locale}
      >
        <SSRProvider>
          <div className="wrap">
            <Header {...{ data: props }} />
            <Component
              siteInfo={props?.siteInfo}
              initData={props}
              {...pageProps}
            />
            <Footer {...{ data: props }} />
          </div>
        </SSRProvider>
      </IntlProvider>
      <style>{styleContent}</style>
    </>
  );
}
// MyApp.getInitialProps = async () => {
//   const socialsResponse = await server.get("/pages/socialLinks");
//   const siteInfo = await server.get("/settings/siteInfo");

//   return {
//     props: {
//       socials: socialsResponse?.data?.data?.page?.sections || [],
//       siteInfo: siteInfo?.data?.data?.siteInfo || siteInfo?.data?.data || {},
//     },
//   };
// };
export default MyApp;

MyApp.getInitialProps = async (appContext) => {
  const appProps = await App.getInitialProps(appContext);
  let baseUrl = null;
  const req = appContext.ctx.req;
  if (req) {
    const hostHeader =
      req.headers["x-forwarded-host"] || req.headers.host || null;
    const protoHeader =
      req.headers["x-forwarded-proto"] ||
      (req.socket?.encrypted ? "https" : "http");
    if (hostHeader) baseUrl = `${protoHeader}://${hostHeader}`;
  }
  if (!baseUrl) baseUrl = process.env.NEXT_PUBLIC_SITE_URL || null;
  const socialsResponse = await server.get("/pages/socialLinks");
  const siteInfo = await server.get("/settings/siteInfo");
  return {
    ...appProps,
    // Pass common props used by Header/Footer and pages
    props: {
      socials: socialsResponse?.data?.data?.page?.sections || [],
      siteInfo: siteInfo?.data?.data?.siteInfo || siteInfo?.data?.data || {},
    },
    pageProps: { ...appProps.pageProps, baseUrl },
  };
};
